// extracted by mini-css-extract-plugin
export default {"buttonContainer":"invite_user_modal_buttonContainer__dlSxJ","fileInfoContainer":"invite_user_modal_fileInfoContainer__ha0HP"};